import { AppDispatch, RootState } from '../../../store'
import { camelize } from 'casing'
import { fetchResellers } from '../../api/markeplace'
import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import { getErrorMessages } from '../../../common/utils/error'
import { AxiosError, AxiosResponse } from 'axios'
import { errorLogger } from '../../../common/utils/errorLogger'
import { RequestFailureMessage } from '../../../common/utils/messagesContants'
import { ResellerInfo } from '../../../admin/modules/resaleAuthorizations/reducer'

import { LoadingTypes, startLoading, stopLoading } from '@labrav/common'
export enum ResellerActions {
  SET_RESELLERS_DATA = 'SET_RESELLERS_DATA',
}

export const getResellersData =
  (partnerId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.RESELLERS_DATA))
    try {
      const { data } = await fetchResellers(partnerId)
      await dispatch(setResellersData(camelize(data).awsResellers))
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.RESELLERS_DATA))
    }
  }

export const setResellersData = (resellers: ResellerInfo[]) => ({
  type: ResellerActions.SET_RESELLERS_DATA,
  payload: resellers,
})
